// Volt — PhonePlay's friendly phone-bot host. All copy is coins-only / no gambling language.
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
const fill = (s, v = {}) => s.replace(/\{(\w+)\}/g, (_, k) => (v[k] ?? ""));

export const PERSONAS = {
  word: { label: "Word nerd", intro: ["Seven letters, sixty seconds. Let's find the fancy words.", "Lexicon loaded. Show me something polysyllabic!", "Rack's hot. Short words are fine, long words are art."] },
  cards: { label: "Card shark (friendly)", intro: ["Shuffle up — chain time. Cool hands, cool head.", "Same deal for everyone. Read the board, ride the chain.", "Cards on the table. Let's see how long you can run it."] },
  coach: { label: "Hype coach", intro: ["Eyes up! Fast hands, faster brain!", "Warm-up's over. Let's see that focus!", "Deep breath. Lock in. GO!"] },
  duel: { label: "Announcer", intro: ["Two players. One game. Who's got the quicker brain tonight?", "{opp} steps into the arena — the crowd is on its feet!", "In this corner: YOU. In that corner: {opp}. Let's get ready to PLAY!"] },
  tournament: { label: "Shout-out", intro: ["Leaderboard check! Climb the board and make the arena learn your name.", "Top of the board is wide open. Think you can take it?", "Standings are live. Every point counts — go claim your spot."] },
  arcade: { label: "Host", intro: ["Lights on, coins ready — have fun out there!", "Welcome to the arcade. Fun Coins only, zero pressure."] },
};

const QUIPS = {
  win: ["Big brain move!", "Boom! That's how it's done.", "Clean. Sharp. Yours.", "Volt approves. Lights are flickering!", "Smooth. Do it again?"],
  bigwin: ["WHOA. My circuits are buzzing!", "MASSIVE! Did you plan that?!", "That one's going on the fridge."],
  loss: ["So close, run it back?", "Shake it off — next one's yours.", "Even robots miss sometimes.", "Reset. Refocus. Replay."],
  draw: ["Dead even! Tiebreaker?", "Mirror match. Run it back!"],
  streak: ["Streak ×{n}! You're on fire!", "{n} in a row — unstoppable!", "×{n}! Someone cool the servers down!"],
  word_win: ["Lexicon unlocked. Pure wordsmithery!", "Dictionary's blushing. Nice words!"],
  word_loss: ["Vocabulary's just warming up. One more rack?", "The letters won this round. Rematch?"],
  cards_win: ["Smooth chain. The cards respect you.", "Cool as the back of a king. Nicely run."],
  cards_loss: ["Deck fought back. Deal again?", "Short chain, long memory. Next deal's yours."],
  coach_win: ["THAT'S my player! Textbook!", "Reflexes of a cat, brain of a calculator!"],
  coach_loss: ["Walk it off — then come back stronger!", "Good reps. Champions lose practice rounds too."],
  daily: ["Daily done! Ranked #{rank} — come back tomorrow to defend it.", "Logged for today. #{rank} on the board — nice work!"],
};

export function greeting(user) {
  const name = user?.name?.split(" ")[0] || "player";
  const h = new Date().getHours();
  const streak = user?.streak_days || 0;
  if (streak >= 3) return fill(pick(["{name}! {streak}-day streak — keep it glowing.", "Back again, {name}? Day {streak}. Legendary consistency."]), { name, streak });
  if (h < 12) return fill(pick(["Morning, {name}! Brain fuel loaded.", "Rise and play, {name}. The arcade's warmed up."]), { name });
  if (h < 18) return fill(pick(["Hey {name}! Volt here — ready to play?", "Afternoon, {name}. Pick a game, I'll cheer."]), { name });
  return fill(pick(["Late session, {name}? I'll keep the lights on.", "Evening, {name}. Let's make it a good one."]), { name });
}

export function quip({ outcome, persona = "arcade", streak = 0, big = false, vars = {} }) {
  if (outcome === "win" && streak >= 3) return fill(pick(QUIPS.streak), { n: streak });
  if (outcome === "win" && big) return pick(QUIPS.bigwin);
  if (outcome === "draw") return pick(QUIPS.draw);
  if (outcome === "daily") return fill(pick(QUIPS.daily), vars);
  const key = `${persona}_${outcome}`;
  return pick(QUIPS[key] || QUIPS[outcome] || QUIPS.win);
}

export function intro(persona, vars = {}) { return fill(pick(PERSONAS[persona]?.intro || PERSONAS.arcade.intro), vars); }

export const personaFor = (game) => ({
  word_volt: "word", solitaire_sprint: "cards", card_21: "cards",
  speed_math: "coach", reaction_rush: "coach", memory_matrix: "coach", skill_reels: "coach", precision_wheel: "coach",
}[game] || "arcade");

export const moodFor = (outcome) => (outcome === "win" ? "cheer" : outcome === "loss" ? "sad" : outcome === "draw" ? "think" : "happy");
